import {
  OVERPAYMENT_GRAPH_DATA_REQUEST,
  OVERPAYMENT_GRAPH_DATA_SUCCESS,
  OVERPAYMENT_DATA_SUCCESS,
  OVERPAYMENT_GRAPH_DATA_LOADING,
  OVERPAYMENT_DATA_LOADING,
  OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_REQUEST,
  OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_LOADING,
  OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_SUCCESS,
  OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_FAILURE,
  OVERPAYMENT_SUBCATEGORY_REQUEST,
  OVERPAYMENT_SUBCATEGORY_SUCCESS,
  OVERPAYMENT_SUBCATEGORY_FAILURE,
  OVERPAYMENT_SUBCATEGORY_LOADING,
} from '../../../actions/actionTypes';

interface PaymentIntegrityState {
  opGraphData: any;
  isLoading: boolean;
  isLoadingGraphData: boolean;
  isLoadingOverpaymentData?: boolean;
  overPaymentCardData: any;
  claimsTrendGraphData?: any;
  claimsTrendGraphIsLoading?: boolean;
  claimsTrendGraphError?: string | null;
  claimsTrendLobData?: any;
  claimsTrendLobIsLoading?: boolean;
  claimsTrendLobError?: string | null;
  financialPerformanceGraphData?: any;
  financialPerformanceGraphInitialResponse?: any;
  financialPerformanceGraphIsLoading?: boolean;
  financialPerformanceGraphError?: string | null;
  financialPerformanceLobData?: any;
  financialPerformanceLobIsLoading?: boolean;
  financialPerformanceLobError?: string | null;
  subCategoryData: { [reasonName: string]: { data: any; loading: boolean; error: any } };
}

const initialState: PaymentIntegrityState = {
  opGraphData: {},
  overPaymentCardData: {},
  isLoading: false,
  isLoadingGraphData: false,
  isLoadingOverpaymentData: false,
  claimsTrendGraphIsLoading: false,
  claimsTrendGraphData: {},
  claimsTrendGraphError: null,
  claimsTrendLobIsLoading: false,
  claimsTrendLobData: {},
  claimsTrendLobError: null,
  financialPerformanceGraphIsLoading: false,
  financialPerformanceGraphData: {},
  financialPerformanceGraphInitialResponse: {},
  financialPerformanceGraphError: null,
  financialPerformanceLobIsLoading: false,
  financialPerformanceLobData: {},
  financialPerformanceLobError: null,
  subCategoryData: {},
};

const OverpaymentReducer = (
  state = initialState,
  action: { type: string; payload?: any }
): PaymentIntegrityState => {
  switch (action.type) {
    case OVERPAYMENT_GRAPH_DATA_REQUEST:
      return {
        ...state,
        subCategoryData: {},
      };

    case OVERPAYMENT_GRAPH_DATA_LOADING:
      return {
        ...state,
        isLoadingGraphData: action.payload,
      };

    case OVERPAYMENT_DATA_LOADING:
      return {
        ...state,
        isLoadingOverpaymentData: action.payload,
      };

    case OVERPAYMENT_GRAPH_DATA_SUCCESS:
      return {
        ...state,
        opGraphData: action.payload,
      };
    case OVERPAYMENT_DATA_SUCCESS:
      return {
        ...state,
        overPaymentCardData: action.payload,
      };

    case OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_LOADING:
      return {
        ...state,
        financialPerformanceGraphIsLoading: action.payload,
      };

    case OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_REQUEST:
      return {
        ...state,
        financialPerformanceGraphIsLoading: true,
      };

    case OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_SUCCESS:
      return {
        ...state,
        financialPerformanceGraphData: action?.payload?.graphResponses,
        financialPerformanceGraphInitialResponse:
          action?.payload?.initialReponse?.Data,
        financialPerformanceGraphIsLoading: false,
      };

    case OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_FAILURE:
      return {
        ...state,
        financialPerformanceGraphError: action.payload,
        financialPerformanceGraphIsLoading: false,
      };

    case OVERPAYMENT_SUBCATEGORY_REQUEST:
      return {
        ...state,
        subCategoryData: {
          ...state.subCategoryData,
          [action.payload.reasonName]: {
            data: null,
            loading: true,
            error: null,
          },
        },
      };

    case OVERPAYMENT_SUBCATEGORY_LOADING:
      return {
        ...state,
        subCategoryData: {
          ...state.subCategoryData,
          [action.payload.reasonName]: {
            ...state.subCategoryData[action.payload.reasonName],
            loading: action.payload.loading,
          },
        },
      };

    case OVERPAYMENT_SUBCATEGORY_SUCCESS:
      return {
        ...state,
        subCategoryData: {
          ...state.subCategoryData,
          [action.payload.reasonName]: {
            data: action.payload.data,
            loading: false,
            error: null,
          },
        },
      };

    case OVERPAYMENT_SUBCATEGORY_FAILURE:
      return {
        ...state,
        subCategoryData: {
          ...state.subCategoryData,
          [action.payload.reasonName]: {
            data: null,
            loading: false,
            error: action.payload.error,
          },
        },
      };

    default:
      return state;
  }
};

export default OverpaymentReducer;
